import { makeStyles, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme";

export const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    },
    button: {
        backgroundColor: themeTokens.colorNeutralForeground2BrandSelected,
        color: themeTokens.colorNeutralBackground1
    },
    message: {
        ...shorthands.margin("10px", "0px"),
        whiteSpace: "pre-wrap"
    },
    selectionRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    }
});
